<template>
    <div class="page-container flex flex-direction flex-sub">
        <div class="flex flex-direction flex-sub"  v-if="readonly || apply">
            <div v-if="Math.abs(state) > 2" :class="state | apply_status_color" class="status flex">
                <div class="text-sm text-white">{{ state | status }}</div>
                <div v-if="state === -4" class="text-sm margin-left-xs text-white">：{{ reason }}</div>
            </div>
            <el-collapse class="margin-top-sm" v-model="curTab" accordion>
                <el-collapse-item :title="item.name" :name="index" v-for="(item,index) in lists" :key="index">
                   <div class="flex flex-direction" v-if="item.title">
                       <div class="text-bold text-black text-df self-center">{{item.title}}</div>
                       <div class="detail margin-top-sm flex-sub" v-html="item.content"></div>
                       <div class="flex flex-direction padding-xs margin-top-sm" v-if="files.length">
                           <div class="text-black text-df text-bold">附件</div>
                           <div v-for="(item,index) in files"
                                :key="index" class="record-item flex align-center justify-between margin-top-xs padding-xs">
                               <div :href="item.file_url" class="file-name title text-sm" target="_blank" @click="toFilePreview(item.file_name,item.file_url)">{{ item.file_name }}</div>
                               <el-button v-if="!readonly" class="el-icon-delete text-orange" type="text" @click="delFile(item,index)"></el-button>
                           </div>
                       </div>
                   </div>
                    <div v-else>暂未填写材料</div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <div class="flex" v-else>
            <div class="model_list-container flex flex-direction flex-shrink flex-sub">
                <div class="text-black text-df text-bold self-center">模板</div>
                <div class="search-container small flex align-center margin-top-sm">
                    <el-input v-model="model_keyword" class="flex-sub" placeholder="请输入关键字"></el-input>
                    <el-button class="search-submit" type="primary" @click="search">搜索</el-button>
                </div>
                <div class="model-item" v-for="(item,index) in models" :key="index">
                    <div class="model_item-title text-bold">{{item.title}}</div>
                    <div class="model_item-content ovHide5 margin-top-xs">{{item.desc}}</div>
                    <div class="flex align-center justify-around margin-top-xs">
                        <el-button round type="primary" plain size="mini" @click="showItem(item)">全文</el-button>
                        <el-button round type="primary" size="mini" @click="copyModel(item)">引用</el-button>
                    </div>
                </div>
                <el-empty v-if="!models.length" image-size="100"></el-empty>
            </div>
            <ck-decoupled-editor class="margin-lr-sm flex-shrink" ref="editor" :title="title" :content="content"></ck-decoupled-editor>
            <div class="operate-container flex flex-direction  flex-shrink flex-sub">

                <div class="reason-container flex flex-direction padding-xs ">
                    <div class="text-black text-df text-bold self-center">附件</div>
                    <div v-for="(item,index) in files"
                         :key="index" class="record-item flex align-center justify-between margin-top-xs padding-xs">
                        <div :href="item.file_url" class="file-name title text-sm cursor" target="_blank" @click="toFilePreview(item.file_name,item.file_url)">{{ item.file_name }}</div>
                        <el-button v-if="!readonly" class="el-icon-delete text-orange" type="text" @click="delFile(item,index)"></el-button>
                    </div>
                    <el-empty v-if="!files.length" image-size="100"></el-empty>
                    <!--                    <el-upload-->
                    <!--                        v-if="!readonly"-->
                    <!--                        :action="FILE_UPLOAD_HOST"-->
                    <!--                        :before-upload="beforeAvatarUpload"-->
                    <!--                        :data="QNData"-->
                    <!--                        :on-error="uploadError"-->
                    <!--                        :on-success="uploadSuccess" :show-file-list="false" class="self-center margin-top-sm">-->
                    <!--                        <el-button class="btn small radius" size="small" type="primary">上传</el-button>-->
                    <!--                    </el-upload>-->
                    <upload-file class="self-center margin-top-sm" @uploadFile="uploadFile" :disabled="readonly">
                        <el-button slot="upload" class="btn small radius" size="small" type="primary">上传</el-button>
                    </upload-file>

                </div>
                <el-button class="bg-orange radius margin-top-sm" type="warning" :loading="requesting" @click="submitInfo()" :disabled="state === 3">保存</el-button><div></div>
                <div class="reason-container flex flex-direction padding-xs margin-top-sm"  v-if="Math.abs(state) > 2">
                    <div class="text-df text-bold self-center" :class="state | status_color">{{ state | status }}</div>
                    <div class="text-sm text-red margin-top-sm" v-if="state === -4">{{ reason }}</div>
                </div>
                <div class="reason-container flex flex-direction padding-xs margin-top-sm">
                    <div class="text-black text-df text-bold self-center">往期修改记录</div>
                    <div class="record-item flex align-center margin-top-xs padding-xs cursor"
                         v-for="(item,index) in historys" :key="index"  @click="showItem(item)">
                        <div class="flex flex-direction justify-around flex-sub ovHide">
                            <div class="record_item-title text-df text-black text-bold ovHide" :title="item.title">{{item.title}}</div>
                            <div class="record_item-time text-xs text-gray margin-top-xs">{{item.create_time}}</div>
                        </div>
                        <i class="el-icon-arrow-right"></i>
                    </div>
                    <el-empty v-if="!historys.length" image-size="100"></el-empty>
                </div>
            </div>
            <template-detail-dialog :dialog-visible="templateDetailDialog" :title="cur_title" :content="cur_content" :time="cur_time" @watchState="watchState"></template-detail-dialog>
        </div>

    </div>
</template>

<script>

import {confirm, formatHtml, toast, TOAST, toFilePreview} from "@/utils/utils";
import CkDecoupledEditor from "@/views/web/components/CKDecoupledEditor";
import {addApplyProjectDeclaration, getApplyModelList, getApplyProjectDeclaration} from "@/api";
import TemplateDetailDialog from "@/views/web/staff/page/apply/components/TemplateDetailDialog";
import UploadFile from "@/views/web/components/UploadFile";

export default {
    components: {UploadFile, TemplateDetailDialog, CkDecoupledEditor},
    name: "ProjectMaterials",
    data() {
        return {
            type:2,
            did:'',
            title:'',
            content:'',
            files:[],
            curTab:0,
            lists:[],
            model_keyword:'',
            models:[],
            historys:[],
            requesting: false,
            cur_title:'',
            cur_content:'',
            cur_time:'',
            templateDetailDialog: false,
        }
    },
    props: {
        pid: {
            type: Number,
            default: 0
        },
        state: {
            type: Number,
            default: 0
        },
        reason: {
            type: String,
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        },
        apply: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        if (this.pid) this.init()
    },
    methods: {
        async init() {
            let _data = await getApplyProjectDeclaration(this.pid,this.type)
            this.lists = _data.data.list
            this.historys = _data.data.history
            if (_data.data.list.length) {
                let item = _data.data.list.find(f=>{ return this.user.mid == f.mid})
                this.readonly = this.readonly || !item ||  !item.edit_able
                this.title = item.title || ''
                this.content = item.content || ''
                this.files = item.file_path ? JSON.parse(item.file_path) : []
                this.did = item.id
            }
            this.search();
        },
        async submitInfo(is_shen = 0) {
            let _info = this.$refs.editor.getInfo()
            if (!_info.content) return  toast('请输入内容', TOAST.error)
            this.requesting = true
            let _data = await addApplyProjectDeclaration(this.did,this.pid,this.type,_info.title,_info.content,JSON.stringify(this.files),is_shen)
            if (_data.status === 200) {
                this.init()
                this.next()
                toast(`${is_shen ? '提交' : '保存'}成功`, TOAST.success)
            } else {
                toast(_data.msg, TOAST.error)
            }
            this.requesting = false
        },
        async search(){
            let _data = await getApplyModelList(this.pid,this.type,this.model_keyword)
            _data.data.map(item=>{
                item.desc = formatHtml(item.content)
            })
            this.models = _data.data
        },
        showItem(item) {
            this.cur_title = item.title
            this.cur_content = item.content
            this.cur_time = item.create_time || ''
            this.templateDetailDialog = true

        },
        watchState() {
            this.templateDetailDialog = false
        },
        copyModel(item) {
            this.title = item.title
            this.content = item.content
        },
        next() {
            this.$emit('watchState', true)
        },
        delFile(item, index) {
            confirm(`删除文件`, `你确定删除<b>${item.file_name}</b>文件吗？`, () => {
                this.files.splice(index, 1)
            }, '确认', true)
        },
        //  上传成功
        uploadFile(data) {
            this.files.push({
                file_name: data.file.name,
                file_url: data.file.url
            })
        },
        toFilePreview(name,url){
            toFilePreview(name,url)
        },
    },
    filters: {
        status(check_status) {
            //0 1提交审核 2通过 -2拒绝 3提交审核 4通过-4拒绝
            switch (Number(check_status)) {
                case 3 :
                    return '审核中'
                case -4 :
                    return '意见建议'
                default:
                    return '已通过'
            }
        },
        status_color(check_status) {
            //验收状态 1正常验收 2非正常验收
            switch (Number(check_status)) {
                case 3 :
                    return 'text-orange'
                case -4 :
                    return 'text-black'
                default:
                    return 'text-green'
            }
        } ,
        apply_status_color(check_status) {
            //验收状态 1正常验收 2非正常验收
            switch (Number(check_status)) {
                case 3 :
                    return 'bg-orange'
                case -4 :
                    return 'bg-red'
                default:
                    return 'bg-green'
            }
        }
    },
    watch: {
        pid() {
            if (this.pid) {
                this.init()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.page-container {
    .status {
        padding: 12px 24px;
    }
    .model_list-container {
        min-width: 290px;
        background-color: #f9f9f9;
        border-radius: 10px;
        border: solid 1px #ececec;
        padding: 10px;
        .model-item {
            background-color: #ffffff;
            border-radius: 10px;
            border: solid 1px #ececec;
            margin-top: 10px;
            padding: 20px;
            .model_item-title {
                font-size: 16px;
                color: #333333;
            }
            .model_item-content {
                font-size: 14px;
                line-height: 24px;
                text-align: justify;
                word-break: break-all;
                color: #333333;
            }
        }
    }
    .operate-container{
        min-width: 290px;
    }
    .reason-container {

        background-color: #f9f9f9;
        border-radius: 10px;
        border: solid 1px #ececec;
        .record-item {
            background-color: #ffffff;
            border-radius: 10px;
            border: solid 1px #ececec;
        }
    }
}
</style>